/* Fiber · Tecnologias — um único modal compartilhado (home + página de produto) */
(() => {
  if (window.__fiberTech) return; window.__fiberTech = true;
  let dlg;
  const ensure = () => {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'fiber-tech-dialog';
    dlg.innerHTML = `<div class="fiber-tech-dialog__card">
      <button type="button" class="fiber-tech-dialog__close" data-close aria-label="Fechar"><svg viewBox="0 0 14 14"><path d="M1 1l12 12M13 1L1 13"/></svg></button>
      <div class="fiber-tech-dialog__icon" data-icon></div>
      <span class="fiber-tech-dialog__eyebrow" data-eyebrow></span>
      <h3 class="fiber-tech-dialog__title" data-title></h3>
      <span class="fiber-tech-dialog__rule"></span>
      <p class="fiber-tech-dialog__text" data-text></p>
      <a class="fiber-tech-dialog__cta" data-cta></a>
    </div>`;
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]') || !e.target.closest('.fiber-tech-dialog__card')) dlg.close();
    });
    return dlg;
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-fiber-tech]');
    if (!t) return;
    const d = ensure();
    d.querySelector('[data-icon]').innerHTML = (t.querySelector('svg') || {outerHTML: ''}).outerHTML;
    d.querySelector('[data-eyebrow]').textContent = 'Tecnologia Fiber' + (t.dataset.num ? ' · ' + t.dataset.num : '');
    d.querySelector('[data-title]').textContent = t.dataset.name || '';
    d.querySelector('[data-text]').textContent = t.dataset.text || '';
    const cta = d.querySelector('[data-cta]');
    if (t.dataset.link) { cta.href = t.dataset.link; cta.textContent = t.dataset.cta || 'Ver produtos'; cta.hidden = false; } else cta.hidden = true;
    d.classList.toggle('fiber-tech-dialog--eco', t.classList.contains('fiber-tech-chip--eco'));
    d.showModal();
    d.querySelector('[data-close]').focus();
  });
})();
